import { Container, Grid, Typography, Paper, Radio, RadioGroup, FormControlLabel, Dialog, DialogActions, DialogContent, DialogContentText, Slide } from '@mui/material';
import React, { useState } from 'react';
import globals from '../../globals';
import RedButton from '../../components/redButton';
import BlueButton from '../../components/blueButton';
import { useAuth } from '../../context/AuthContext';
import TextFieldRedBackground from '../../components/text_filed_red_background';

const weeks = [
    { id: 'week-1', label: 'Седмица I (03.08.2026 - 07.08.2026)' },
    { id: 'week-2', label: 'Седмица II (10.08.2026 - 14.08.2026)' },
    { id: 'week-3', label: 'Седмица III (17.08.2026 - 21.08.2026)', disabled: true },
    { id: 'week-4', label: 'Седмица IV (24.08.2026 - 28.08.2026)' },
];

const redRadioSx = { color: globals.colors.lightRed, '&.Mui-checked': { color: globals.colors.lightRed } };

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SummerSchoolCheckoutPage = () => {
    const { token } = useAuth();
    const [selectedWeek, setSelectedWeek] = useState('');
    const [childName, setChildName] = useState('');
    const [grade, setGrade] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [checkoutLoading, setCheckoutLoading] = useState(false);

    const isValid = Boolean(selectedWeek && childName.trim() && grade);

    const handleCheckout = () => {
        setCheckoutLoading(true);
        fetch(`${globals.apiUrl}/summer-school/create-checkout`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ week: selectedWeek, child_name: childName.trim(), grade, currency: 'EUR' }),
        })
            .then(res => res.json())
            .then(data => {
                if (data.url) window.location.href = data.url;
                else setCheckoutLoading(false);
            })
            .catch(() => setCheckoutLoading(false));
    };

    return (
        <Container maxWidth='md'>
            <Paper sx={{ borderRadius: 2, mt: 5, mb: 5, py: 4, px: { xs: 2, sm: 6 } }} elevation={4}>
                <Grid container direction='column' alignItems='center' spacing={3}>
                    <Grid item>
                        <Typography sx={{ fontSize: 30, fontWeight: 'bold', color: globals.colors.lightRed, textAlign: 'center' }}>Избор на седмица</Typography>
                    </Grid>
                    <Grid item>
                        <Typography sx={{ fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>Изберете седмицата от август, в която искате детето ви да участва в лятната занималня.</Typography>
                    </Grid>
                    <Grid item>
                        <RadioGroup value={selectedWeek} onChange={(e) => setSelectedWeek(e.target.value)}>
                            {weeks.map((w) => (
                                <FormControlLabel
                                    key={w.id}
                                    value={w.id}
                                    disabled={w.disabled}
                                    control={<Radio sx={redRadioSx} />}
                                    label={<Typography sx={{ fontWeight: 'bold', color: w.disabled ? globals.colors.gray : globals.colors.lightRed }}>{w.label}</Typography>}
                                />
                            ))}
                        </RadioGroup>
                    </Grid>
                    <Grid item sx={{ width: '100%' }}>
                        <Typography sx={{ fontSize: 20, fontWeight: 'bold', color: globals.colors.darkBlue, textAlign: 'center', mb: 1 }}>Две имена на детето:</Typography>
                        <TextFieldRedBackground
                            fullWidth
                            value={childName}
                            onChange={(e) => setChildName(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <Typography sx={{ fontSize: 20, fontWeight: 'bold', color: globals.colors.darkBlue, textAlign: 'center', mb: 1 }}>Клас:</Typography>
                        <RadioGroup row value={grade} onChange={(e) => setGrade(e.target.value)} sx={{ justifyContent: 'center' }}>
                            <FormControlLabel value='3' control={<Radio sx={redRadioSx} />} label={<Typography sx={{ fontWeight: 'bold' }}>3.</Typography>} />
                            <FormControlLabel value='4' control={<Radio sx={redRadioSx} />} label={<Typography sx={{ fontWeight: 'bold' }}>4.</Typography>} />
                        </RadioGroup>
                    </Grid>
                    <Grid item sx={{ mt: 2 }}>
                        <RedButton
                            text='Продължи към плащане'
                            disabled={!isValid}
                            onClick={() => setOpenDialog(true)}
                            pX={5}
                            sx={{ fontSize: 18, py: 1.5, fontWeight: 'bold' }}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Dialog
                open={openDialog}
                slots={{ transition: Transition }}
                keepMounted
                onClose={() => setOpenDialog(false)}
                aria-describedby='alert-dialog-slide-description'
            >
                <DialogContent>
                    <DialogContentText id='alert-dialog-slide-description'>
                        <Grid container justifyContent='center' textAlign='center'>
                            <Grid item>
                                <img src='/popup_stripe.webp' width={150} height={170} alt='' />
                            </Grid>
                            <Grid item>
                                <Typography sx={{ fontSize: 17, color: globals.colors.darkBlue, fontWeight: 'bold' }}>Ще бъдеш пренасочен към защитена външна страница за сигурно плащане.</Typography>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <BlueButton onClick={() => setOpenDialog(false)} sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }} text='Откажи' />
                    <RedButton
                        onClick={handleCheckout}
                        disabled={checkoutLoading}
                        text={checkoutLoading ? 'Зареждане...' : 'Продължи'}
                        sx={{ textTransform: 'capitalize', fontWeight: 'bold', fontSize: 16, width: 120 }}
                    />
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default SummerSchoolCheckoutPage;
